import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import './EditUser.scss';
import Ebutton from '../../../common/components/Ebutton/Ebutton';
import PropTypes from 'prop-types';
import {useFormik} from 'formik';
import actions from '../../../redux/actions';
import * as yup from 'yup';
import {CuitInput, CustomSelect} from '../../../common/components/CustomInputs/CustomInputs';
import _ from 'lodash';
import plusSvg from '../../../images/plus.svg';
import minusSvg from '../../../images/minus.svg';
import {useHistory} from 'react-router-dom';
import Loading from '../../../common/components/Loading/Loading';
import CustomAlert from '../../../common/components/Alert/CustomAlert';

/**
 * @description
 * @param { object } props no redux
 * @return { * } component
 */
const InputErrorMessage = ({formik, name, className = ''}) => {
    return (
        <div className={'form-error ' + className}>
            {_.get(formik.touched, name) && _.get(formik.errors, name)}
        </div>
    );
};

const NewPhone = ({index, deleteFunc, formik}) => {
    useEffect(() => {
        if (formik.values?.phoneNumbers[index + 1] !== undefined) {
            return () => {
            };
        }
        formik.values.phoneNumbers[index + 1] = {type: 'PERSONAL', number: ''};
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <div className="eu-div-input">
                <select className="eu-input-l w20" placeholder={'Cateoria'}
                        name={`phoneNumbers[${index + 1}].type`}
                        value={formik.values.phoneNumbers[index + 1]?.type}
                        defaultValue="PERSONAL"
                        onChange={formik.handleChange}
                >
                    <option value="PERSONAL" selected>Personal</option>
                    <option value="OFFICE">Oficina</option>
                    <option value="OTHER">Otro</option>
                </select>
                <input className="eu-input-m" placeholder={'Numero'}
                       name={`phoneNumbers[${index + 1}].number`}
                       value={formik.values.phoneNumbers[index + 1]?.number}
                       onChange={formik.handleChange}
                       required
                />
                <Ebutton classNameButton="eu-input-br" type="button" text={<img src={minusSvg} alt={'minus'}/>}
                         onClick={deleteFunc}/>
            </div>
            <div className="eu-div-input">
                <InputErrorMessage formik={formik} name={`phoneNumbers[${index + 1}].number`} className='eu-input-l'/>
            </div>
        </>
    );
};

const EditUser = (props) => {
    const {
        name,
        getBranches,
        getBranchesProviders,
        branches,
        branchesProviders,
        providerSelected,
        userSelected,
        editProviderState,
        cleanEditUserState,
        putProvider,
        currentUser,
        getBranchesState,
        getBranchesProvidersState,
        cleanBranches,
        cleanProvidersBranches,
        selectSelf,
        setSelfState,
        cleanSelectSelf,
        showSidebar,
    } = props;
    const validationSchema = yup.object({
        // password: yup
        //     .string('Ingrese contraseña')
        //     .required('Ingrese contraseña'),
        email: yup
            .string('Ingrese email')
            .email('email inválido')
            .required('Ingrese email'),
        phoneNumbers: yup.array().of(
            yup.object().shape({
                type: yup
                    .string('Ingrese tipo')
                    .required('Ingrese tipo'),
                number: yup.string().when('type', {
                    is: 'OTHER',
                    then: yup.string('Ingrese número')
                        .required('Ingrese número'),
                    otherwise: yup.string('Ingrese número')
                        .matches(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/,
                            'Número Inválido (No olvide colocar el código de área)')
                        .required('Ingrese número'),
                }),
            }),
        )
            .required('Teléfonos requeridos'),
    });

    useEffect(() => {
        cleanSelectSelf();
        cleanBranches();
        cleanProvidersBranches();
        // solo para admins, si es provider admin solo deberia ver su sede
        if (!currentUser) {
            getBranches();
        } else {
            selectSelf();
        }
        // eslint-disable-next-line
    }, []);

    const history = useHistory();

    useEffect(
        () => {
            if (editProviderState.success) {
                cleanEditUserState();
                history.goBack();
            }
            // eslint-disable-next-line
        }, [editProviderState],
    );

    const formik = useFormik({
        initialValues: {
            id: providerSelected?.providerModel ?
                providerSelected?.providerModel?.id :
                providerSelected?.id ?
                    providerSelected.id :
                '',
            email: providerSelected?.user?.email ? providerSelected.user.email : userSelected.email || '',
            password: providerSelected?.user?.password ? providerSelected.user?.password : '',
            name: providerSelected?.providerModel ?
                providerSelected?.providerModel?.name :
                providerSelected?.name ?
                    providerSelected.name :
                    '',
            cuitOrCuil: providerSelected?.providerModel ?
                providerSelected?.providerModel?.cuitOrCuil :
                providerSelected?.cuitOrCuil ?
                    providerSelected.cuitOrCuil :
                    '',
            phoneNumbers: providerSelected?.providerModel ?
                providerSelected?.providerModel?.phoneNumbers :
                providerSelected?.phoneNumbers ?
                    providerSelected.phoneNumbers :
                    '',
            type: providerSelected?.user?.role?.name || '',
            salesforceProviderId: providerSelected?.providerModel ?
                providerSelected?.providerModel?.salesforceProviderId :
                providerSelected?.salesforceProviderId ?
                    providerSelected.salesforceProviderId :
                    '',
            salesforceBranchId: providerSelected?.providerModel ?
                providerSelected?.providerModel?.salesforceBranchId :
                providerSelected?.salesforceBranchId ?
                    providerSelected.salesforceBranchId :
                    '',
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            const body = {
                id: values.id,
                user: currentUser ?
                    _.omit(values, ['id', 'name', 'cuitOrCuil', 'type', 'salesforceProviderId', 'salesforceBranchId', 'password', 'email']) :
                    _.omit(values, ['id', 'name', 'cuitOrCuil', 'type', 'salesforceProviderId', 'salesforceBranchId', 'password']),
                type: values.type === 'PROVIDER_USER' ? 'user' : 'admin',
            };
            putProvider(body);
        },
    });


    useEffect(() => {
        if (currentUser && setSelfState.success) {
            getBranches();
        }
        // eslint-disable-next-line
    }, [currentUser, setSelfState.success]);

    useEffect(() => {
        formik.resetForm({values: {...formik.values, salesforceBranchId: ''}});
        if (formik.values.type === 'PROVIDER_USER' && formik.values.salesforceProviderId && branches.length > 0) {
            getBranchesProviders(formik.values.salesforceProviderId);
        }
        // eslint-disable-next-line
    }, [formik.values.salesforceProviderId, branches]);

    const [nextPhone, setNextPhone] = useState(0);
    const [phoneKeys, setPhoneKeys] = useState([]);
    const [branchesOptions, setBranchesOptions] = useState([]);
    const [branchesProvidersOptions, setBranchesProvidersOptions] = useState([]);

    useEffect(() => {
        if (!providerSelected) return null;
            const keyLen = currentUser ? providerSelected.providerModel.phoneNumbers?.length - 1 : providerSelected.phoneNumbers?.length - 1;
            setPhoneKeys([...Array(keyLen)].map((x, i) => i));
            setNextPhone(keyLen);
        // eslint-disable-next-line
    }, [providerSelected]);

    useEffect(() => {
        setBranchesOptions(branches?.map((branch) => {
            if (branch.providerId === 'a1l2K000005fIfrQAE') {
                branch.fullName = 'Prestador sin sede';
            }
            return {value: branch.providerId.toString(), label: branch.fullName};
        }));
    }, [branches, getBranchesState.success]);

    useEffect(() => {
        setBranchesProvidersOptions(branchesProviders?.map((branch) => {
            return {value: branch.branchId.toString(), label: branch.fullName};
        }));
        formik.setFieldValue('salesforceBranchId', providerSelected?.salesforceBranchId || '');
        // eslint-disable-next-line
    }, [branchesProviders, getBranchesProvidersState.success]);

    const addPhone = () => {
        setPhoneKeys([...phoneKeys, nextPhone]);
        setNextPhone(nextPhone + 1);
    };

    const deletePhone = (key, index = null) => {
        if (index) formik.values.phoneNumbers.splice(index, 1);
        setPhoneKeys(phoneKeys.filter((k) => k !== key));
    };

    return (getBranchesState.success ?
        providerSelected?.providerModel || providerSelected?.user ?
        <div className={showSidebar && window.innerWidth <= 700 ? 'ul-div-background bg-mt-10' : 'ul-div-background'}>
            <p className="ul-p-name">{name}</p>
            <div className="ul-div-section">
                <div className="ul-div-sect-header">
                    <div>
                        <p className="ul-p-title">{currentUser ? 'MIS DATOS' : 'EDITAR USUARIO DE PRESTADOR'}</p>
                        <hr id="id-hr"/>
                    </div>
                </div>

                    <div className="ul-div-form">

                        <form className="eu-form" onSubmit={formik.handleSubmit}>
                            <input type="hidden" name="password" value={formik.values.password}
                                   onChange={formik.handleChange}/>
                            <input type="hidden" name="zipCode" value={formik.values.zipCode}
                                   onChange={formik.handleChange}/>
                            {currentUser ?
                                (
                                    <div className="eu-radio-container change-pass"
                                         onClick={() => history.push('/change_password')}
                                         style={{cursor: 'pointer'}}
                                    >Cambiar contraseña
                                    </div>
                                ) : (
                                    <div className="eu-radio-container">
                                        <input
                                            disabled={true}
                                            type={'radio'}
                                            value={'PROVIDER_ADMIN'}
                                            name={'providerAdmin'}
                                            className="eu-radio"
                                            checked={formik.values.type === 'PROVIDER_ADMIN'}
                                        /> Admin de prestador
                                        <input
                                            disabled={true}
                                            type={'radio'}
                                            value={'PROVIDER_USER'}
                                            name={'providerUser'}
                                            className="eu-radio"
                                            checked={formik.values.type === 'PROVIDER_USER'}
                                        /> Usuario de sede
                                    </div>
                                )}

                            <div className="eu-div-container">
                                <div className="eu-div-input">
                                    <text className="eu-text-l eu-f-label">Nombre</text>
                                    <text className="eu-text-s eu-f-label">CUIT/CUIL</text>
                                </div>
                                <div className="eu-div-input">
                                    <input className="eu-input-l" name="name" value={formik.values.name}
                                           onChange={formik.handleChange}
                                           disabled={true}
                                    />
                                    <CuitInput className="eu-input-s" name="cuitOrCuil" value={formik.values.cuitOrCuil}
                                               onChange={formik.handleChange}
                                               disabled={true}
                                    />
                                </div>
                                <div className="eu-div-input">
                                    <InputErrorMessage formik={formik} name='name' className='eu-input-l'/>
                                    <InputErrorMessage formik={formik} name='cuitOrCuil' className='eu-input-s'/>
                                </div>
                                <div className="eu-div-input">
                                    <text className="eu-text-l eu-f-label">E-mail</text>
                                    <text className="eu-text-s eu-f-label">Prestador</text>
                                </div>
                                <div className="eu-div-input">
                                    <input
                                        className="eu-input-l" name="email" value={formik.values.email}
                                        onChange={formik.handleChange}
                                        // disabled
                                        disabled={!currentUser ? false : true}
                                    />
                                    <CustomSelect
                                        name="salesforceProviderId"
                                        className='eu-input-s eu-select'
                                        onChange={(value) => formik.setFieldValue('salesforceProviderId', value.value)}
                                        value={formik.values.salesforceProviderId}
                                        options={branchesOptions}
                                        isSearchable={true}
                                        disabled={true}
                                    />
                                </div>
                                <div className="eu-div-input">
                                    <InputErrorMessage formik={formik} name='email' className='eu-input-l'/>
                                    <InputErrorMessage formik={formik} name='salesforceProviderId'
                                                       className='eu-input-s'/>
                                </div>
                                {formik.values.type === 'PROVIDER_USER' &&
                                    <>
                                        <div className="eu-div-input">
                                            <text className="eu-text-l eu-f-label">Sede</text>
                                        </div>
                                        <div className="eu-div-input">
                                            <CustomSelect
                                                name="salesforceBranchId"
                                                className='eu-input-l eu-select'
                                                onChange={(value) => formik.setFieldValue('salesforceBranchId', value?.value)}
                                                value={formik.values.salesforceBranchId}
                                                options={branchesProvidersOptions}
                                                disabled={true}
                                                isSearchable={true}
                                                isClearable={true}
                                            />
                                        </div>
                                        <div className="eu-div-input">
                                            <InputErrorMessage formik={formik} name='salesforceBranchId'
                                                               className='eu-input-l'/>
                                        </div>
                                    </>
                                }
                                <div className="eu-div-input">
                                    <text className="eu-text-l eu-f-label">Teléfono</text>
                                </div>
                                <div className="eu-div-input">
                                    <select className="eu-input-l w20" placeholder={'Categoria'}
                                            name="phoneNumbers[0].type" value={formik.values?.phoneNumbers[0]?.type}
                                            onChange={formik.handleChange}
                                    >
                                        <option value="PERSONAL">Personal</option>
                                        <option value="OFFICE">Oficina</option>
                                        <option value="OTHER">Otro</option>
                                    </select>
                                    <input className="eu-input-m" placeholder={'Numero'}
                                           name="phoneNumbers[0].number" value={formik.values?.phoneNumbers[0]?.number}
                                           onChange={formik.handleChange}
                                    />
                                    <Ebutton classNameButton="eu-input-br" type="button"
                                             text={<img src={plusSvg} alt={'plus'}/>} onClick={addPhone}/>
                                </div>
                                <div className="eu-div-input">
                                    <InputErrorMessage formik={formik} name='phoneNumbers[0].number'
                                                       className='eu-input-l'/>
                                </div>
                                {phoneKeys.map((k, i) =>
                                    <NewPhone key={k} index={i} deleteFunc={() => deletePhone(k, i + 1)}
                                              formik={formik}/>,
                                )}
                                <Ebutton classNameButton="eu-btn" type="submit" text="GUARDAR CAMBIOS"/>
                            </div>

                        </form>
                    </div>
                </div>
            </div> : <Loading className="ul-div-sect-table"/> :
        getBranchesState.loading ? <Loading className="ul-div-sect-table"/> :
            <CustomAlert text={'planes' || String(getBranchesState.error)} severity='error'/>);
};

const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    branches: state.home.branches,
    branchesProviders: state.home.branchesProviders,
    providerSelected: state.home.providerSelected,
    userSelected: state.login.userInfo,
    editProviderState: state.home.editProviderState,
    getBranchesState: state.home.getBranchesState,
    getBranchesProvidersState: state.home.getBranchesProvidersState,
    setSelfState: state.home.setSelfState,
    showSidebar: state.common.showSidebar,
});

const mapDispatchToProps = (dispatch) => ({
    getBranches: () => dispatch(actions.home.getBranchesRequest()),
    getBranchesProviders: (id) => dispatch(actions.home.getBranchesProvidersRequest(id)),
    putProvider: (providerSelected) => dispatch(actions.home.putProviderRequest(providerSelected)),
    cleanEditUserState: () => dispatch(actions.home.cleanEditUserState()),
    cleanGetBranchesState: () => dispatch(actions.home.cleanGetBranchesState()),
    cleanBranches: () => dispatch(actions.home.cleanBranches()),
    cleanProvidersBranches: () => dispatch(actions.home.cleanProvidersBranches()),
    selectSelf: () => dispatch(actions.home.selectSelf()),
    cleanSelectSelf: () => dispatch(actions.home.cleanSelectSelf()),
});

EditUser.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
};


export default connect(mapStateToProps, mapDispatchToProps)(EditUser);

